import { memo } from 'react';

import { CloudUpload } from 'lucide-react';

import { cn } from '@/shadcn/lib/utils';

interface Props {
  completed?: number;
}

export const ProgressBar = memo(({ completed = 0 }: Props) => (
  <div
    className="flex w-full items-baseline gap-2"
    data-cy="forms-js-progress-bar"
  >
    <div className="relative flex h-1.5 w-full overflow-hidden rounded-lg">
      <div className="absolute inset-0 z-1 animate-pulse bg-accent" />
      <div
        className={cn(
          'z-2 h-full rounded-lg bg-primary transition-all ease-in'
        )}
        style={{ width: `${completed}%` }}
      />
    </div>
    <div className="inline-flex gap-2 font-semibold">
      <span>{`${completed}%`}</span>
      <CloudUpload size={16} />
    </div>
  </div>
));
